import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import {
  isEmptyObject,
  getDateByStringDate,
  getYearsByDate,
  getDataCountryByIso3,
  isValidDateByStringDate,
  getBithdateByStringDate,
  getExpirationDateByStringDate,
  getExpeditionDateByStringDate,
} from '../utils/index';

// const interfaceDataOCR = {
//   name: '',
//   // firstName: '',
//   country: '',
//   documentNumber: '',
//   expeditionDate: '',
//   gender: '',
//   lastNames: '',
//   birthDate: '',
//   documentType: '',
//   expirationDate: '',
//   nationality: '',
//   applySignPassport: false,
//   customBirthDate: '',
// };

const regexWordsClear = '\\bundefined\\b';
const clearCaracter = '[^a-zA-ZáéíóúüñÁÉÍÓÚÜÑ´\\s]';
const regex = new RegExp(clearCaracter, 'g');
const regexWordClear = new RegExp(regexWordsClear, 'gmi');

function useGetDataOcr() {
  const { documentType, dataOCR } = useSelector((state) => state.ocr);
  const { FechaEntrada } = useSelector((state) => state.guests.selectedGuest);

  const [OCRData, setOCRData] = useState({});

  // console.log({ dataOCR });

  useEffect(() => {
    if (!isEmptyObject(dataOCR)) {
      let {
        name = '',
        // firstName,
        lastNames = '',
        birthDate = '',
        gender = '',
        expeditionDate = '',
        expirationDate: expirationDateFront = '',
        signature = false,
      } = dataOCR?.front || {};
      const {
        documentNumber = '',
        expirationDate: expirationDateReverse = '',
        country = '',
      } = dataOCR?.reverse || {};

      const dataCountry = getDataCountryByIso3(country);
      // console.log({ expirationDateFront })
      let expirationDate = getExpirationDateByStringDate(expirationDateFront);
      // console.log(expirationDate)
      // if (expirationDateFront !== '' && isValidDateByStringDate(expirationDateFront, 'DD/MM/YY')) {
      //   expirationDate = getDateByStringDate(expirationDateFront, 'DD/MM/YY');
      // }

      // if (expirationDateReverse !== '' && isValidDateByStringDate(expirationDateReverse, 'DD/MM/YY')) {
      //   expirationDate = getDateByStringDate(expirationDateReverse, 'DD/MM/YY');
      // }
      if (expirationDate === '' && expirationDateReverse !== '') {
        expirationDate = getExpirationDateByStringDate(expirationDateReverse);
      }

      name = name.replace(regex, '');
      name = name.replace(regexWordClear, '');

      lastNames = lastNames.replace(regex, '');
      lastNames = lastNames.replace(regexWordClear, '');

      // console.log("birthDate 1", birthDate);
      const inputValues = {
        // ...interfaceDataOCR,
        name,
        // firstName,
        lastNames,
        birthDate: getBithdateByStringDate(birthDate),
        gender,
        // expirationDate: getDateByStringDate(expirationDate, 'DD/MM/YYYY'),
        // expeditionDate: getDateByStringDate(expeditionDate, 'DD/MM/YYYY'),
        expirationDate,
        expeditionDate: getExpeditionDateByStringDate(expeditionDate, FechaEntrada),
        nationality: dataCountry.nameES,
        country: dataCountry.iso2,
        documentNumber,
        documentType,
        applySignPassport: signature,
        customBirthDate: `0${getYearsByDate(getDateByStringDate(birthDate, 'DD/MM/YYYY'))}`,
      };
      // console.log("birthDate 2", birthDate);

      setOCRData(inputValues);
    }

    return () => {};
  }, [FechaEntrada, documentType, dataOCR]);

  return { OCRData };
}

export default useGetDataOcr;
